
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Swal from 'sweetalert2';
import '../bootstrap';
import '../plugins';
//import Vue from 'vue';

//window.Vue = Vue;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });


function votacaoContas() {
    const id = 'votacao-contas';
    const form = document.querySelector(`form#${id}`);
    if (form) {
        const btnSubmit = form.querySelector('button[type="submit"]');

        if (btnSubmit) {
            btnSubmit.addEventListener('click', (e) => {
                e.preventDefault();

                const data = $(`form#${id}`).serializeArray();
                const countVotos = Array.from(form.querySelectorAll('input[type="radio"]')).length / 2;


                const countTotalVotos = data.reduce((acc, { name, value }) => (name.includes('voto_contas') ? acc += 1 : acc), 0);

                if (countTotalVotos === countVotos) {

                    const options = data
                                .filter(({name}) => name.includes('voto_contas'))
                                .reduce((acc, curr) => {
                                    const inpt = document.getElementById(curr.name)
                                    const pt = inpt.parentElement.parentElement                             
                                    const v = pt.querySelector('.card-header').textContent

                                    acc += `
                                    <tr>
                                        <td>${v}</td>
                                        <td>${curr.value == 1 ? 'Sim' : 'Não'}</td>
                                    </tr>
                                    `
                                    return acc;
                                }, '');


                                Swal.fire({
                                    title: 'Confirma os votos?',
                                    html: `
                                        <table class="table table-bordered">
                                            <thead>
                                                <th>Opção</th>
                                                <th>Voto</th>
                                            </thead>
                                            <tbody>
                                                ${options}
                                            </tbody>
                                        </table>
                                    `,
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Sim, confirmar!',
                                    cancelButtonText: 'Cancelar'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        form.submit();
                                    }
                                })


                }
                else {
                    toastr.error('Informe o seu voto para todas as questões!');
                    return false;
                }


            });
        }
    }
}


function votacaoObras(){
    const form = document.querySelector("form#votacao-obras");

    if (form) {
        const btnSubmit = form.querySelector('button[type="submit"]');

        if (btnSubmit) {
            btnSubmit.addEventListener('click', (e) => {
                e.preventDefault();

                const data = $("form#votacao-obras").serializeArray();
                const countVotos = Array.from(form.querySelectorAll('input[type="radio"]')).length / 2;


                const countTotalVotos = data.reduce((acc, { name, value }) => (name.includes('voto_contas') ? acc += 1 : acc), 0);

                console.log(data);
                console.log(countVotos, countTotalVotos);

                if (countTotalVotos === countVotos) {

                    const options = data
                                .filter(({name}) => name.includes('voto_contas'))
                                .reduce((acc, curr) => {
                                    const inpt = document.getElementById(curr.name)
                                    const pt = inpt.parentElement.parentElement                             
                                    const v = pt.querySelector('.card-header').textContent

                                    acc += `
                                    <tr>
                                        <td>${v}</td>
                                        <td>${curr.value == 1 ? 'Sim' : 'Não'}</td>
                                    </tr>
                                    `
                                    return acc;
                                }, '');


                                Swal.fire({
                                    title: 'Confirma os votos?',
                                    html: `
                                        <table class="table table-bordered">
                                            <thead>
                                                <th>Opção</th>
                                                <th>Voto</th>
                                            </thead>
                                            <tbody>
                                                ${options}
                                            </tbody>
                                        </table>
                                    `,
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Sim, confirmar!',
                                    cancelButtonText: 'Cancelar'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        form.submit();
                                    }
                                })


                }
                else {
                    toastr.error('Informe o seu voto para todas as questões!');
                    return false;
                }


            });
        }
    }
}


votacaoContas();
votacaoObras();

Inputmask({
    mask: ['999.999.999-99'],
    keepStatic: true,
    autoUnmask: true,
    removeMaskOnSubmit: true,
}).mask(document.querySelector('.cpf'))

// Inputmask({ alias: "datetime", inputFormat: "dd/mm/yyyy" }).mask(document.querySelector('.email'))